import React from "react";

function AcessDenied() {
  return (
    <div>
      <div className="flex justify-center h-screen">
        <div className="my-auto">Access Denied</div>
      </div>
    </div>
  );
}

export default AcessDenied;
